import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { ButtonBase } from '@material-ui/core'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { uniq } from 'lodash'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 8,
    height: 30,
    padding: '2px 6px 2px 6px',
    backgroundColor: 'white',
    cursor: 'pointer',
    position: 'absolute',
    bottom: -7,
    left: 10,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
  },
  alignRight: {
    left: 'auto',
    right: 28
  }
}))

const ReactionsDisplay = ({ alignLeft, reactions }) => {
  const classes = useStyles()
  const parsedReactions = JSON.parse(reactions || '{}')
  const reactionEmojis = uniq(
    Object.keys(parsedReactions).map(emojiByUserId => parsedReactions[emojiByUserId].reaction)
  )
  const shouldDisplayReactions = reactionEmojis.length > 0

  return (
    shouldDisplayReactions && (
      <div>
        <ButtonBase className={`${classes.container} ${alignLeft ? '' : classes.alignRight}`}>
          {reactionEmojis.map((emoji, index) => (
            <DazzedParagraph14
              key={`${emoji}-${index}`}
              style={{ marginRight: index < reactionEmojis.length - 1 ? 8 : 0 }}
            >
              {emoji}
            </DazzedParagraph14>
          ))}
        </ButtonBase>
      </div>
    )
  )
}

export default ReactionsDisplay
